var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-container',{staticClass:"mpd-side-panel-page-json"},[_c('pre',{staticClass:"text-color-black"},[_vm._v(_vm._s(JSON.stringify(_vm.json, null, 2)))])])}
var staticRenderFns = []

export { render, staticRenderFns }